import { get, toLower } from 'lodash'
const { SIGN_IN_OVERRIDE } = process.env

function isPoratlSignInEnabled(communityConfig) {
  return (
    get(communityConfig, 'portalSignInEnabled') ||
    toLower(SIGN_IN_OVERRIDE) === 'true'
  )
}

export default isPoratlSignInEnabled
